import { useCallback, useRef, useState } from "react";

import "assets/css/distribution.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import { apiPost } from "apis/api";
import Modal from "components/modal";
import commonUtil from "utils/common";

import PageTab from "components/common/pageTab";
import TopImage from "components/common/topImage";
import ImgUrl from 'assets/images/business.png';

import { pageMenuTabList02 } from 'types/common';

const Proposal = () => {
  pageMenuTabList02[2].on = true;

  const companyRef = useRef<HTMLInputElement>(null);
  const nameRef = useRef<HTMLInputElement>(null);
  const emailRef = useRef<HTMLInputElement>(null);
  const phoneRef = useRef<HTMLInputElement>(null);
  
  let objResult = {
    strResult: "N"
  };

  const ingredientListProp = [
    { id: "고시형원료", status: false, text: "" },
    { id: "개별인정형원료", status: false, text: "" },
    { id: "일반식품원료", status: false, text: "" },
    { id: "기타", status: false, text: "" },
    { id: "미정", status: false, text: "" },
  ];

  const formProp = [
    { id: "치어팩(M방형)", status: false, text: "", capacity : "40~200ml", url:"https://img.chunhomall.com/images/brand_site/oemodm-section-01_300x300.png" },
    { id: "치어팩(스탠딩)", status: false, text: "" , capacity : "40~200ml", url:"https://img.chunhomall.com/images/brand_site/oemodm-section-02_300x300.png"},
    { id: "치어팩(안전캡)", status: false, text: "" , capacity : "40~200ml", url:"https://img.chunhomall.com/images/brand_site/oemodm-section-03_300x300.png"},
    { id: "사면팩", status: false, text: "", capacity : "40~80ml", url:"https://img.chunhomall.com/images/brand_site/oemodm-section-04_300x300.png"},
    { id: "액상스틱", status: false, text: "", capacity : "10~25mL", url:"https://img.chunhomall.com/images/brand_site/oemodm-section-08_300x300.png"},
    { id: "젤리스틱", status: false, text: "", capacity : "15~25g", url:"https://img.chunhomall.com/images/brand_site/oemodm-section-09_300x300.png"},
    { id: "소환", status: false, text: "", capacity : "3~4g", url:"https://img.chunhomall.com/images/brand_site/oemodm-section-06_300x300.png"},
    { id: "대환", status: false, text: "", capacity : "4.0~4.5g", url:"https://img.chunhomall.com/images/brand_site/oemodm-section-07_300x300.png"},
    { id: "바이알", status: false, text: "", capacity : "20~30mL", url:"https://img.chunhomall.com/images/brand_site/product-section-vial-06.png"},
    { id: "멀티캡 바이알", status: false, text: "", capacity : "20~30mL", url:"https://img.chunhomall.com/images/brand_site/product-section-vial-02.png"},
    { id: "멀티캡 치어팩", status: false, text: "", capacity : "50~150mL", url:"https://img.chunhomall.com/images/brand_site/product-section-vial-05.png"},
  ];

  const productTypeProp = [
    { id: "미정", status: false, text: "" },
    { id: "과채주스", status: false, text: "" },
    { id: "과채음료", status: false, text: "" },
    { id: "인삼홍삼음료", status: false, text: "" },
    { id: "혼합음료", status: false, text: "" },
    { id: "추출가공식품", status: false, text: "" },
    { id: "액상차", status: false, text: "" },
    { id: "과채가공품", status: false, text: "" },
    { id: "기타가공품", status: false, text: "" },
    { id: "당류가공품", status: false, text: "" },
  ];
  const customTargetProp = [
    { id: "온가족(연령구분없음)", status: false, text: "" },
    { id: "어린이", status: false, text: "" },
    { id: "청소년(10대)", status: false, text: "" },
    { id: "청소년(20~30대)", status: false, text: "" },
    { id: "중년증", status: false, text: "" },
    { id: "장년층", status: false, text: "" },
    { id: "여성", status: false, text: "" },
    { id: "남성", status: false, text: "" },
    { id: "기타", status: false, text: "" },
  ];

  const distributionProp = [    
    { id: "온라인", status: false, text: "" },
    { id: "홈쇼핑", status: false, text: "" },
    { id: "오프라인", status: false, text: "" },
    { id: "급식", status: false, text: "" }    
  ];
  
  const distributionOtherProp = [
    { id: "해외", status: false, text: "" },
    
  ];
  
  
  const [isOpenModal, setOpenModal] = useState<boolean>(false);

  const onClickToggleModal = useCallback(() => {
    setOpenModal(!isOpenModal);
  }, [isOpenModal]);

  const [modalCon, setModalCon] = useState(""); 

  const [ingredientlList, setIngredientList] = useState(ingredientListProp); 
  
  const [formList, setFormList] = useState(formProp);
  const [customTargetList, setCustomTargetList] = useState(customTargetProp);
  const [productTypeList, setProductTypeList] = useState(productTypeProp);
  const [distributionList, setDistributionList] = useState(distributionProp);
  const [distributionOtherList, setDistributionOtherList] = useState(distributionOtherProp);

  const [subIngredient, setSubIngredient] = useState("");
  const [company, setCompany] = useState("");
  const [url, setUrl] = useState("");
  const [department, setdepartment] = useState("");
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [businessYN, setBusinessYN] = useState("N");
  const [sales, setSales] = useState("50억미만");
  const [employee, setEmployee] = useState("5인 이하");  
  const [goods, setGoods] = useState("");
  const [prodname, setProdName] = useState("");
  const [prodconcept, setProdConcept] = useState("");
  const [prodtarget, setProdTarget] = useState("");
  const [production, setProduction] = useState("");
  const [capacity, setCapacity] = useState("");
  const [requestinfo, setRequestInfo] = useState("");
  
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    // TODO: send data to server
    let businessData = {
      prodname: prodname,
      prodconcept: prodconcept,
      prodtarget: prodtarget,
      ingredientlList: ingredientlList,
      subIngredient : subIngredient,
      productTypeList: productTypeList,
      formList: formList,
      capacity : capacity,
      production : production,
      customTargetList: customTargetList,
      distributionList: distributionList,      
      distributionOtherList: distributionOtherList,
    };

    let paramData = {
      type: 'I',
      company: company,
      name : name,
      url: url,
      department: department,
      phone : phone,
      email : email,
      businessYN: businessYN,
      sales: sales,
      employee: employee,
      goods: goods,
      requestinfo: requestinfo,

      businessData : JSON.stringify(businessData)

    };
    
    const setData = async () => {
      try {
        const response = await apiPost<{ strResult: string }>('/board/setInquiryData', paramData);
        console.log(response.strResult);

        if(response.strResult === "Y"){

          setCompany("");
          setUrl("");
          setdepartment("");
          setName("");
          setPhone("");
          setEmail("");
          setBusinessYN("N");
          setSales("50억미만");
          setEmployee("5인 이하");  
          setGoods("");
          setProdName("");
          setProdConcept("");
          setProdTarget("");
          setProduction("");
          setCapacity("");
          setSubIngredient("");
          setRequestInfo("");

          distributionOtherList.forEach(item => {
            item.status = false;
            item.text = "";
          });

          distributionList.forEach(item => item.status = false);
          productTypeList.forEach(item => item.status = false);
          formList.forEach(item => item.status = false);
          customTargetList.forEach(item => item.status = false);
          ingredientlList.forEach(item => item.status = false);

          alert('내용이 전달 되었습니다.');

        }else{
          alert('전달중 문제가 발생하였습니다.');
        }

      } catch (error) {
        console.error(axios.isAxiosError(error) ? error.message : error);
      }
    };

    if(company === ""){
      setModalCon('회사명을 입력해주세요.');
      setOpenModal(true);
      companyRef.current?.focus();

      return false;
    }

    if(name === ""){
      setModalCon('이름을 입력해주세요.');
      setOpenModal(true);
      nameRef.current?.focus();

      return false;
    }

    if(phone === ""){
      setModalCon('연락처를 입력해주세요.');
      setOpenModal(true);
      phoneRef.current?.focus();

      return false;
    }

    if(commonUtil.checkEmail(email) === false){
      setModalCon('이메일형식에 맞지 않습니다.');
      setOpenModal(true);
      emailRef.current?.focus();

      return false;
    }

    setData();

  };
  const inputboxHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    const handlers: { [key: string]: React.Dispatch<React.SetStateAction<string>> } = {
      url: setUrl,
      business: setBusinessYN,
      sales: setSales,
      employee: setEmployee,
    };

    const handler = handlers[name];
    if (handler) {
      handler(value);
    } else {
      console.log(`unknown input name: ${name}`);
    }
  };

  const ItemHandler = (listType: string, type: string, e: React.ChangeEvent<HTMLInputElement>, item: any, idx: number) => {
    const newList =
      listType === "ingredientlList"
        ? [...ingredientlList]
        //: listType === "formList"
        //? [...formList]
        
        : listType === "customTargetList"
        ? [...customTargetList]
        : listType === "productTypeList"
        ? [...productTypeList]
        : listType === "distributionList"
        ? [...distributionList]
        : listType === "distributionOtherList"
        ? [...distributionOtherList]
        : [];
        
    const newExtList =
      listType === "formList"
      ? [...formList]
      : [];
  
    if(listType==="formList"){
      if (type === "check") newExtList[idx].status = e.target.checked;
      if (type === "text") newExtList[idx].text = e.target.value;
    }else{
      console.log(newList[idx]);

      if (type === "check") newList[idx].status = e.target.checked;
      if (type === "text") newList[idx].text = e.target.value;
    }
    
    switch (listType) {
      case "ingredientlList":
        setIngredientList(newList);
        break;
      case "formList":
        console.log(newList);
        setFormList(newExtList);
        break;
      case "customTargetList":
        setCustomTargetList(newList);
        break;
        case "productTypeList":
          setProductTypeList(newList);
          break;
      case "distributionList":
        setDistributionList(newList);
        break;
      case "distributionOtherList":
        setDistributionOtherList(newList);
        break;
    }    
  };

  const distributionRendering = () => {
    const result = [];

    for (let i = 0; i < distributionList.length; i++) {
      result.push(
        <label className="input-style" key={i}>
          <input type='checkbox' id={distributionList[i].id} checked={distributionList[i].status === true} onChange={(e) => ItemHandler('distributionList', 'check', e, distributionList[i], i)} />{distributionList[i].id}
        </label>
      );
    }
    return result;
  }
  const distributionOtherRendering = () => {
    const result = [];

    for (let i = 0; i < distributionOtherList.length; i++) {   
      result.push(
        <div className="check-item" key={i}>
          <div style={{display:"Flex"}}>
            <label className="input-style">
            <input type='checkbox' id={distributionOtherList[i].id} checked={distributionOtherList[i].status === true} onChange={(e) => ItemHandler('distributionOtherList', 'check', e, distributionOtherList[i], i)} />{distributionOtherList[i].id}
            </label>
          </div>
          <div>
            <input type="text" placeholder={`수출국가`} value={distributionOtherList[i].text} onChange={(e) => ItemHandler('distributionOtherList', 'text', e, distributionOtherList[i], i)} />
          </div>
        </div>
      );
    }
    
    return result;
  };

  return (
    <div className="page_content">
      <TopImage imgUrl="https://img.chunhomall.com/images/brand_site/oemodm-hero_1920x1080.jpg.jpg" imgText="OEM/ODM 문의" textcolor="#FFF"></TopImage>
      <PageTab props={pageMenuTabList02}></PageTab>

      <div className="distribution">
        <div className="container">
          <form onSubmit={handleSubmit}>

            <div className="proposal">
              <div className="tbl-title">기본정보</div>
              <table className="tbl-proposal">
                <colgroup>
                  <col style={{ width: "210px" }} />
                  <col style={{ width: "410px" }} />
                  <col style={{ width: "210px" }} />
                  <col style={{ width: "410px" }} />
                </colgroup>
                <tbody>
                  <tr>
                    <th scope="col">
                      <div className="th-style">
                        <div>
                          <FontAwesomeIcon icon={faCircle} className="point color-red" />
                        </div>
                        <div>
                          업체명
                        </div>
                      </div>
                    </th>
                    <td>
                      <div className="input-value">
                        <input ref={companyRef} type="text" name="company" value={company} onChange={(e) => setCompany(e.target.value)} />
                      </div>
                    </td>
                    <th scope="col">
                      <div className="th-style">
                        <div>
                          <FontAwesomeIcon icon={faCircle} className="point" />
                        </div>
                        <div>
                          홈페이지 URL
                        </div>
                      </div>
                    </th>
                    <td>
                      <div className="input-value">
                        <input type="text" name="url" value={url} onChange={(e) => setUrl(e.target.value)} />
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th scope="col">
                      <div className="th-style">
                        <div>
                          <FontAwesomeIcon icon={faCircle} className="point" />
                        </div>
                        <div>
                          부서
                        </div>
                      </div>
                    </th>
                    <td>
                      <div className="input-value">
                        <input type="text" name="department" value={department} onChange={(e) => setdepartment(e.target.value)} placeholder="예)마케팅,영업,총무,..." />
                      </div>
                    </td>
                    <th scope="col">
                      <div className="th-style">
                        <div>
                          <FontAwesomeIcon icon={faCircle} className="point color-red" />
                        </div>
                        <div>
                          성함
                        </div>
                      </div>
                    </th>
                    <td>
                      <div className="input-value">
                        <input ref={nameRef} type="text" name="name" value={name} onChange={(e) => setName(e.target.value)} />
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th scope="col">
                      <div className="th-style">
                        <div>
                        <FontAwesomeIcon icon={faCircle} className="point color-red" />
                        </div>
                        <div>
                          연락처
                        </div>
                      </div>
                    </th>
                    <td>
                      <div className="input-value">
                        <input ref={phoneRef} type="text" name="phone" value={phone} onChange={(e) => setPhone(commonUtil.getNumberOnly(e.target.value))} maxLength={11} placeholder="'-' 제외하고 입력하세요" />
                      </div>
                    </td>
                    <th scope="col">
                      <div className="th-style">
                        <div>
                        <FontAwesomeIcon icon={faCircle} className="point color-red" />
                        </div>
                        <div>
                          이메일
                        </div>
                      </div>
                    </th>
                    <td>
                      <div className="input-value">
                        <input ref={emailRef} type="text" name="email" value={email} onChange={(e) => setEmail(e.target.value)} />
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th scope="col">
                      <div className="th-style">
                        <div>
                          <FontAwesomeIcon icon={faCircle} className="point" />
                        </div>
                        <div>
                          기존 식품 사업 운영 여부
                        </div>
                      </div>
                    </th>
                    <td>
                      <div className="input-value">
                        <label className="input-style">
                          <input type="radio" name="business" value={'Y'} onChange={inputboxHandler} checked={businessYN === 'Y'} />있음
                        </label>
                        <label className="input-style">
                          <input type="radio" name="business" value={'N'} onChange={inputboxHandler} checked={businessYN === 'N'} />없음
                        </label>
                      </div>
                    </td>
                    <th scope="col">
                      <div className="th-style">
                        <div>
                          <FontAwesomeIcon icon={faCircle} className="point" />
                        </div>
                        <div>
                          직원수
                        </div>
                      </div>
                    </th>
                    <td>
                      <div className="input-value">
                        <label className="input-style">
                          <input type="radio" name="employee" value={'5인 이하'} onChange={inputboxHandler} checked={employee === '5인 이하'} /> 2인 이하
                        </label>
                        <label className="input-style">
                          <input type="radio" name="employee" value={'5인 초과'} onChange={inputboxHandler} checked={employee === '5인 초과'} /> 5인 초과
                        </label>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th scope="col">
                      <div className="th-style">
                        <div>
                          <FontAwesomeIcon icon={faCircle} className="point" />
                        </div>
                        <div>
                          기존 판매제품(브랜드)
                        </div>
                      </div>
                    </th>
                    <td colSpan={3}>
                      <div className="input-value">
                        <input type="text" name="goods" value={goods} onChange={(e) => setGoods(e.target.value)} />
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="proposal" style={{marginTop:"20px"}}>
              <div className="tbl-title">사업문의</div>
              <table className="tbl-proposal">
                <colgroup>
                  <col style={{ width: "210px" }} />
                  <col style={{ width: "1030px" }} />
                </colgroup>
                <tbody>
                <tr>
                    <th scope="col">
                      <div className="th-style">
                        <div>
                          <FontAwesomeIcon icon={faCircle} className="point" />
                        </div>
                        <div>
                          제품명(가안)
                        </div>
                      </div>
                    </th>
                    <td>
                      <div className="input-value flex-direction-col">  
                        <div className="check-item">
                          <div style={{display:"flex"}}>
                            <input type="text" name="prodname" value={prodname} onChange={(e) => setProdName(e.target.value)} />
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th scope="col">
                      <div className="th-style">
                        <div>
                          <FontAwesomeIcon icon={faCircle} className="point" />
                        </div>
                        <div>
                          제품컨셉
                        </div>
                      </div>
                    </th>
                    <td>
                      <div className="input-value flex-direction-col">  
                        <div className="check-item">
                          <div style={{display:"flex"}}>
                            <input type="text" name="prodconcept" value={prodconcept} onChange={(e) => setProdConcept(e.target.value)} />
                          </div>
                        </div>
                        <div className="check-item">
                          <div style={{ display: "flex", fontWeight: "bold" }}>
                            타겟제품
                          </div>
                          <div style={{paddingLeft:"10px"}}>
                            <input type="text" name="prodtarget" value={prodtarget} onChange={(e) => setProdTarget(e.target.value)} placeholder="타겟제품이 있으시면 제품명 또는 링크를 입력해 주세요"/>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th scope="col">
                      <div className="th-style">
                        <div>
                          <FontAwesomeIcon icon={faCircle} className="point" />
                        </div>
                        <div>
                          주원료(복수선택가능)
                        </div>
                      </div>
                    </th>
                    <td>
                      <div className="input-value">
                        {ingredientlList.map((item, idx) => (
                          
                          <label className="input-style" key={idx}>
                            <input type='checkbox' id={item.id} checked={ingredientlList[idx].status === true} onChange={(e) => ItemHandler('ingredientlList', 'check', e, item, idx)} />{item.id}
                          </label>
                          
                        ))}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th scope="col">
                      <div className="th-style">
                        <div>
                          <FontAwesomeIcon icon={faCircle} className="point" />
                        </div>
                        <div>
                          부원료
                        </div>
                      </div>
                    </th>
                    <td>
                      <div className="input-value">
                        <input type="text" name="sub" value={subIngredient} onChange={(e) => setSubIngredient(e.target.value)} />
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th scope="col">
                      <div className="th-style">
                        <div>
                          <FontAwesomeIcon icon={faCircle} className="point" />
                        </div>
                        <div>
                          식품유형(복수선택가능)
                        </div>
                      </div>
                    </th>
                    <td>
                      <div className="input-value">
                        {productTypeList.map((item, idx) => (
                          <label className="input-style" key={idx}>
                            <input type='checkbox' id={item.id} checked={productTypeList[idx].status === true} onChange={(e) => ItemHandler('productTypeList', 'check', e, item, idx)} />{item.id}
                          </label>
                        ))}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th scope="col">
                      <div className="th-style">
                        <div>
                          <FontAwesomeIcon icon={faCircle} className="point" />
                        </div>
                        <div>
                          제형(복수선택가능)
                        </div>
                      </div>
                    </th>
                    <td>
                      <div className="input-value">
                        {formList.map((item, idx) => (
                          <div className="formtype" key={idx}>
                            <div className="item-formtype">
                              <img src={item.url} alt={item.id}/>
                              <div className="item-desc">
                                <div>용량</div><div>{item.capacity}</div>
                              </div>
                              <div className="item-formtype-btn">
                                <label className="input-style" >
                                  <input type='checkbox' id={item.id} checked={formList[idx].status === true} onChange={(e) => ItemHandler('formList', 'check', e, item, idx)} />{item.id}
                                </label>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th scope="col">
                      <div className="th-style">
                        <div>
                          <FontAwesomeIcon icon={faCircle} className="point" />
                        </div>
                        <div>
                          희망 내용량
                        </div>
                      </div>
                    </th>
                    <td>
                      <div className="input-value">
                        <input type="text" name="capacity" placeholder="100mL X 10팩" value={capacity} onChange={(e) => setCapacity(e.target.value)} />
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th scope="col">
                      <div className="th-style">
                        <div>
                          <FontAwesomeIcon icon={faCircle} className="point" />
                        </div>
                        <div>
                          초도 생산량
                        </div>
                      </div>
                    </th>
                    <td>
                      <div className="input-value">
                        <input type="text" name="production" placeholder="낱팩 단위로 작성해주세요." value={production} onChange={(e) => setProduction(e.target.value)} />
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th scope="col">
                      <div className="th-style">
                        <div>
                          <FontAwesomeIcon icon={faCircle} className="point" />
                        </div>
                        <div>
                          타겟고객(복수선택가능)
                        </div>
                      </div>
                    </th>
                    <td>
                      <div className="input-value">
                        {customTargetList.map((item, idx) => (
                          <label className="input-style" key={idx}>
                            <input type='checkbox' id={item.id} checked={customTargetList[idx].status === true} onChange={(e) => ItemHandler('customTargetList', 'check', e, item, idx)} />{item.id}
                          </label>
                        ))}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th scope="col">
                      <div className="th-style">
                        <div>
                          <FontAwesomeIcon icon={faCircle} className="point" />
                        </div>
                        <div>
                          유통채널(복수선택가능)
                        </div>
                      </div>
                    </th>
                    <td>
                      <div className="input-value">
                        {distributionRendering()}
                      </div>
                      <div className="input-value">
                        {distributionOtherRendering()}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="proposal" style={{marginTop:"20px"}}>
              <table className="tbl-proposal">
                <colgroup>
                  <col style={{ width: "210px" }} />
                  <col style={{ width: "1030px" }} />
                </colgroup>
                <tbody>
                  <tr>
                    <th scope="col">
                      <div className="th-style">
                        <div>
                          <FontAwesomeIcon icon={faCircle} className="point" />
                        </div>
                        <div>
                          요청사항
                        </div>
                      </div>
                    </th>
                    <td>
                      <div className="input-value flex-direction-col">  
                        <div className="check-item">
                          <div style={{display:"flex", width: "100%"}}>
                            <textarea rows={10} style={{ width: "100%"}} name="requestInfo" value={requestinfo} placeholder="자세한 요청사항을 기입해 주세요" onChange={(e) => setRequestInfo(e.target.value)} />
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div style={{padding:"20px 0px 0px 0px"}}>
              <button type="submit" className="btn-gray">제출</button>
            </div>
          </form>
      </div>
        
      </div>
      {isOpenModal && (
        <Modal onClickToggleModal={onClickToggleModal}>          
          {modalCon}
        </Modal>
      )}
    </div>
  );
};

export default Proposal;
